// ─────────────────────────────────────────────
//  The one deliberate bypass of the sandbox swap.
//
//  In sandbox mode `db` from firebase/config IS the local store, so nothing
//  routed through firebase/firestore can reach the real database — which is the
//  whole point. But an organization request must reach it. So this module takes
//  its own handle, in exactly one place, explicitly.
//
//  The matching rule is create-only and self-attributed, and denies reads to
//  every client including admins; these are read with the Admin SDK.
// ─────────────────────────────────────────────
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import app from "../firebase/config";

export async function submitOrgRequest({
  uid, orgName, facilityType, orCount, contactEmail, source, wizardAnswers = null,
}) {
  const realDb = getFirestore(app);
  const ref = await addDoc(collection(realDb, "org_requests"), {
    uid, orgName, facilityType, orCount, contactEmail, source,
    wizardAnswers,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}
